import APIS_CONSTANTS from "./ApiConstants";
import http from "./http";

class ReferralServices {
  sendOtp() {
    return http.post(APIS_CONSTANTS.referralSendOtp);
  }

  verifyOtp({ referral_token }) {
    return http.post(APIS_CONSTANTS.referralVerifyOtp, null, {
      params: { referral_token },
      silentError: true
    });
  }

  referralLink() {
    return http.get(APIS_CONSTANTS.referralLink, { silentError: true });
  }

  referralresendOtp() {
    return http.post(APIS_CONSTANTS.referralResendOtp, null, {
      silentError: true
    });
  }

  getReferralChildren(pageNo = 0, pageSize = 20) {
    return http.get(APIS_CONSTANTS.referralChildren, {
      params: { pageNo, pageSize },
    });
  }

  getAccountSummary() {
    return http.get(APIS_CONSTANTS.bankAccountSummary);
  }
}

export default new ReferralServices();
